import { Address } from 'viem';

import { Network } from '@/shared/types/Network';

export const pointsDomains = {
  local: 'http://localhost:8000',
  prod: 'https://api.mellow.finance',
  staging: 'https://api.stage.mellow.finance',
} as const;

export const pointsDomain =
  pointsDomains[process.env.MODE as keyof typeof pointsDomains] || pointsDomains.staging;

export const zeroAddress: Address = '0x0000000000000000000000000000000000000000';
export const ethAddress: Address = '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE';
export const stETHAddress: Partial<Record<Network, Address>> = {
  ethereum: '0xae7ab96520DE3A18E5e111B5EaAb095312D7fE84',
};
export const wstETHAddress: Partial<Record<Network, Address>> = {
  ethereum: '0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0',
};

export function isNativeCurrency(address?: string) {
  return address === zeroAddress || address === ethAddress;
}
